import * as React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import {Provider} from 'react-redux';
import store from '../../components/store.js'
import { ProductTypComponent } from './ProductTypComponent';
import { ConfigurationProduct } from '././configure-product/ConfigurationProduct';

//should  be removed after all verison management ui producType changes done 6.0.60
export function SetupProductTypeLayout() {
  return (
    <Provider store={store}>
      <div>
        <BrowserRouter>
          <Switch>
            <Route path={"/product-types"} component={ConfigurationProduct}/> 
          </Switch>
        </BrowserRouter>
      </div>
    </Provider>

  )
}
